import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UiCoreModule } from "@softline/ui-core";
import {
    BackNavigable,
    BackNavigationService,
    BlockingLoadingSpinnerComponent,
    showRequestErrors, HeaderComponent,
    ScannerModule,
    SOFTLINE_FEATURE_TITLE, Step,
    StepHeaderComponent,
    TitleStore
} from "@softline/application";
import { Store } from "@softline/core";
import { Router } from "@angular/router";
import { LagerkorrekturArtikelStore } from "../../store";
import { SOFTLINE_FEATURE_LAGERKORREKTUR_ARTIKEL } from "../../lagerkorrektur-artikel.shared";
import { Lagerplatz, LagerplatzSucheComponent } from "@softapps/lager/core";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: 'soft-quelllagerplatz-scannen',
    imports: [CommonModule, UiCoreModule, ScannerModule, StepHeaderComponent, BlockingLoadingSpinnerComponent, LagerplatzSucheComponent, HeaderComponent],
    templateUrl: './lagerplatz-scannen.page.html',
    styleUrls: ['./lagerplatz-scannen.page.css']
})
export class LagerplatzScannenPage implements OnInit, OnDestroy, BackNavigable {

  loading$ = new BehaviorSubject<boolean>(false)

  readonly steps: Step[] = [
    {
      header: '#LAGERKORREKTUR_ARTIKEL.PAGES.LAGERPLATZ_SCANNEN.TITLE',
      subHeader: '#LAGERKORREKTUR_ARTIKEL.PAGES.LAGERPLATZ_SCANNEN.DESCRIPTION'
    },
    {
      header: '#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.DESCRIPTION'
    },
    {
      header: '#LAGERKORREKTUR_ARTIKEL.PAGES.MENGEN_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR_ARTIKEL.PAGES.MENGEN_AUSWAHL.DESCRIPTION'
    },
    {
      header: '#LAGERKORREKTUR_ARTIKEL.PAGES.UMBUCHUNGSARTIKEL_AUSWAHL.TITLE',
      subHeader: '#LAGERKORREKTUR_ARTIKEL.PAGES.UMBUCHUNGSARTIKEL_AUSWAHL.DESCRIPTION'
    },
  ];
  constructor(private store: Store,
              private router: Router,
              private backNavigationService: BackNavigationService,
              private zone: NgZone) {
  }

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#LAGERKORREKTUR_ARTIKEL.TITLE')
  }

  ngOnDestroy() {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '')
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/'])
  }

  async onLagerplatzSelected(lagerplatz: Lagerplatz): Promise<void> {
    if(!lagerplatz)
      return;

    this.loading$.next(true);
    try {
      await this.store.dispatch(SOFTLINE_FEATURE_LAGERKORREKTUR_ARTIKEL, LagerkorrekturArtikelStore.actions.loadLagerplatz, lagerplatz.barcode);
      this.loading$.next(false);
      await this.router.navigate(['/lagerkorrektur-artikel/artikel-auswahl'])
    }
    catch (e) {
      this.loading$.next(false);
      showRequestErrors(this.store, e);
    }
  }
}
